<template>
  <div>
    <div class="banner-wrapper" v-if="bannerUrl">
      <div class="banner_info" :style="`background: url(${bannerUrl}) center no-repeat;background-size: cover;`"
           v-if="leftData.length>0 && leftData[0]">
        <dl>
          <dt>{{ leftData[0].name }}</dt>
          <dd>{{ leftData[0].name_en }}</dd>
        </dl>
      </div>
    </div>
    <div class="infopage">
      <!--      显示条件 是证书查询栏目，并且是中联-->
      <!--      <div class="container" v-if="$store.state.stations.name.includes('中联') && currentItem.name=='证书查询' ">-->
      <!--        &lt;!&ndash;中联&ndash;&gt;-->
      <!--        <zl_certification @zlQueryClick="queryClick"  />-->
      <!--      </div>-->
      <!--      <div class="container" v-if="!$store.state.stations.name.includes('中联') && $store.state.stations.id != 1">-->
      <!--        <certification @queryClick="queryClick" />-->
      <!--      </div>-->
      <div class="container" v-if="currentItem.name=='证书查询' || currentItem.name =='Certificate' ">
        <certifications @queryClick="queryClick"/>
        <template>
          <div class="right right_lg">
            <div class="box">
              <div class="title flex lg">
                <div class="flex_item"><b class=""> {{ style == 1 ? '证书公告' : 'Certificate inquiry' }}</b></div>
                <div class="bread">
                  <a href="">{{ style == 1 ? '首页' : 'Home' }}</a> > <a href="">
                  {{ style == 1 ? '证书公告' : 'Certificate inquiry' }}</a>
                </div>
              </div>
              <template >
                <certAdv></certAdv>
              </template>
            </div>
          </div>
        </template>
      </div>

      <div class="container" v-if="currentItem.name=='实验室查询'">
        <testing/>
      </div>

      <!--其他风格模型-->
      <div class="container clearfix">
        <!-- 未查询的语句-->

        <template v-if="!showAnnounce">
          <!--左侧导航分类展示11111-->

          <template v-if="leftData.length > 0 && leftData[0].children.some(item => item.children.length > 0)">
            <div class="left"
                 v-if="(leftData.length > 0 && leftData[0].template != 'picture_column') || columnPid !=0 ">
              <div class="box" v-for="(item,index) in leftData[0].children" :key="item.id" v-if="item.isShow == 1">
                <dl v-if="index==0">
                  <dt>{{ leftData[0].name }}</dt>
                  <dd>{{ leftData[0].name_en }}</dd>
                </dl>
                <!-- 有子栏目才显示 -->
                <template v-if="item.children.length > 0">
                  <h3 :class="{on:(item.id == columnId || item.id == columnPid),mt:index==0}">
                    <a href="javascript:;" @click="navTo(item)">{{ item.name }}</a>
                    <span><i></i></span>
                  </h3>
                  <ul>
                    <template
                        v-if="item.id == columnId || item.parent_id == pid || item.id == columnPid || (columnId == pid && index == 0)">
                      <li @click="navTo(val)" v-for="(val,i) in item.children" :key="val.id"
                          :class="{on:(columnId==val.id) || (columnId==item.id && i==0) || (columnId == pid && index == 0 && i==0)}" v-if="val.isShow == 1">
                        <a href="javascript:;" >{{ val.name }}</a>
                      </li>
                    </template>
                  </ul>
                </template>
                <!-- 没有子栏目时显示二级栏目 -->
                <template v-else>
                  <ul>
                    <li @click="navTo(item)" :class="{on:item.id == columnId || (columnId==pid && index ==0)}" v-if="item.isShow == 1">
                      <a href="javascript:;" >{{ item.name }}</a>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="left">
              <div class="box"
                   v-if="(leftData.length > 0 && leftData[0].template != 'picture_column' && leftData[0].children.length > 0) || columnPid !=0 ">
                <dl>
                  <dt class="pt">{{ leftData[0].name }}</dt>
                </dl>
                <ul>
                  <li @click="navTo(val)" :class="{on:val.id == columnId || (columnId==pid && i ==0)}"
                      v-for="(val,i) in leftData[0].children" :key="val.id"
                      v-if="val.name!='客户关注'&&val.name!='培训园地'&& val.isShow == 1">
                    <a href="javascript:;" >{{ val.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <!--          图片展示栏目-->
          <div class="right right_lg" v-if="currentItem.template == 'picture_column'">

            <div class="box">
              <pictureColumn :columns="leftData[0]" :pid="pid"></pictureColumn>
            </div>

          </div>

          <div class="right right_lg"
               v-else-if="currentItem.template == 'common_list' && leftData[0].children.length==0">
            <div class="box">
              <div class="title flex lg">
                <div class="flex_item"><b
                    class="">{{ currentItem.name == '证书查询' ? '证书公告' : currentItem.name }}</b></div>
                <div class="bread">
                  <a href="#">{{ style == 1 ? '首页' : 'Home' }}</a> >
                  <a href="#" v-if="leftData.length>0">{{  leftData[0].name }}</a>
                </div>
              </div>
              <!--这里特殊处理 可能展示证书公告的内容-->
              <template v-if="currentItem.name == '证书查询'">
                <certAdv></certAdv>
              </template>
              <commonList v-else :column-id="columnId" :pid="pid" :id="currentItem.id"></commonList>
            </div>

          </div>

          <div class="right right_lg"
               v-else-if="currentItem.template == 'cert_query' && leftData[0].children.length==0">
            <div class="box">
              <div class="title flex lg">
                <div class="flex_item"><b class="">{{ currentItem.name }}</b></div>
                <div class="bread">
                  <a href="#">{{ style == 1 ? '首页' : 'Home' }}</a> > <a href="#"
                                                                          v-if="leftData.length>0">{{
                    leftData[0].name
                  }}</a>
                </div>
              </div>
              <certQuery :column-id="columnId" :pid="pid" :id="currentItem.id"></certQuery>
            </div>

          </div>


          <div class="right" :class="{right_lg:columnId==pid && leftData.length > 0 && leftData[0].children.length==0}"
               v-else>
            <div class="box" v-if="currentItem.name!='证书查询' && currentItem.name!='实验室查询'">
              <div class="title flex lg" v-if="currentItem">
                <div class="flex_item"><b class="">{{ currentItem.name }}</b></div>
                <div class="bread">
                  <a href="/">{{ style == 1 ? '首页' : 'Home' }}</a> >
                  <a href="#" v-if="leftData.length>0">{{ leftData[0].name}}</a>
                  > <span>{{ currentItem.name }}</span>
                </div>
              </div>
              <div class="newsitem">
                <channel :id="currentItem.id" v-if="currentItem.template == 'channel'"></channel>
                <develop v-if="currentItem.template == 'develop'"></develop>
              </div>
              <traningPlan :column-id="columnId" :pid="pid" :id="currentItem.id" :column="currentItem"
                           v-if="currentItem.name=='培训计划'"></traningPlan>
              <certificationApplication v-else-if="currentItem.name == '认证申请'"></certificationApplication>
              <trainingApplication :preData="plans" v-else-if="currentItem.name == '培训申请'"></trainingApplication>
              <survey :column-id="columnId" :pid="pid" v-else-if="currentItem.name == '客户调查列表'"></survey>
              <message v-else-if="currentItem.name == '客户留言'"></message>
              <feedback v-else-if="currentItem.name == '意见、建议反馈'"></feedback>
              <dateList :column-id="columnId" :pid="pid" :id="currentItem.id"
                        v-else-if="currentItem.template == 'date_list'"></dateList>
              <pictureList :column-id="columnId" :pid="pid" :id="currentItem.id"
                           v-else-if="currentItem.template == 'picture_list'"></pictureList>
              <commonList :column-id="columnId" :pid="pid" :id="currentItem.id" :column="currentItem"
                          v-else-if="currentItem.template == 'common_list'"></commonList>
              <pictureNews :column-id="columnId" :pid="pid" :id="currentItem.id"
                           v-else-if="currentItem.template == 'picture'"></pictureNews>
              <!-- <feedback v-if="pid == 727 || pid == 728"></feedback> -->
              <feedback v-if="currentItem.id == 742 || currentItem.id == 746" :id="currentItem.id"></feedback>

              <div class="linkBox" v-if="show">
                <div>
                  <div class="lista clearfix">
                    <a class="liDiv" target="_blank" v-for="(item,index) in showdata" :key="index" @click="navTos(item)">{{
                        item.name
                      }}</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </template>
        <template v-else>
          <div class="right right_lg">
            <div class="box">
              <div class="title flex lg">
                <div class="flex_item"><b class=""> {{ style == 1 ? '证书查询' : 'Certificate inquiry' }}</b></div>
                <div class="bread">
                  <a href="">{{ style == 1 ? '首页' : 'Home' }}</a> > <a href="">
                  {{ style == 1 ? '证书查询' : 'Certificate inquiry' }}</a>
                </div>
              </div>
              <certQuery ref="cert" :column-id="columnId" :query="queryParam" :pid="pid"
                         :id="currentItem.id"></certQuery>

            </div>

          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import traningPlan from "@/components/traningPlan";
import certification from "@/components/certification";
import certifications from "@/components/certifications";
import zl_certification from "@/components/zlCertification";
import channel from "@/components/channel";
import develop from "@/components/develop";
import dateList from "@/components/dateList";
import pictureList from "@/components/pictureList";
import commonList from "@/components/commonList";
import certificationApplication from "@/components/certificationApplication";
import trainingApplication from "@/components/trainingApplication";
import pictureColumn from "@/components/pictureColumn";
import survey from "@/components/survey";
import message from "@/components/message";
import feedback from "@/components/feedback";
import pictureNews from "@/components/pictureNews";
import certQuery from "@/components/certQuery";
import certAdv from "@/components/certAdv";
import testing from "@/components/testing";

import {mapMutations, mapState} from "vuex";
import {getChildByColumn} from "@/network/api";

export default {
  name: "channels",
  components: {
    certification,
    zl_certification,
    channel,
    develop,
    dateList,
    pictureList,
    commonList,
    certificationApplication,
    trainingApplication,
    pictureColumn,
    survey,
    message,
    feedback,
    pictureNews,
    certQuery,
    traningPlan,
    certAdv,
    certifications,
    testing
  },
  data() {
    return {
      columnId: 0,
      pid: 0,
      leftData: [],
      columnPid: 0,
      currentItem: {},
      showAnnounce: false,
      queryParam: {},
      planId: 0,
      plans: {},
      style: 1,
      show:false,
      showdata:{}
    }
  },
  mounted() {
    this.style = process.env.VUE_APP_BASE_STYLE
    $("#left").hide();
    $("#right").hide();
    this.setShowTips(false)
    this.columnId = this.$route.params.id.slice(0, -5);
    if (this.columnId == 629) {
      this.columnId = 647;
    }
    this.pid = this.$route.params.pid;
    this.planId = this.$route.query.planId || 0;

    if (this.planId > 0) {
      this.getPlanDetail()
    }
    //设置索引值
    let index = this.columnData.findIndex(item => item.id == this.pid)
    if (index != -1) {
      this.setTabIndex(index + 1);
    }
    console.log(this.pid);
    this.getAllColumn();
  },
  methods: {
    ...mapMutations(['setShowTips', 'setTabIndex']),
    async getPlanDetail() {
      let res = await this.$api.getArticleData({
        id: this.planId
      });
      console.log(res, '====');
      this.plans = res.data.data
    },
    async getAllColumn() {
      let res = await this.$api.getAllColumn({
        pid: this.pid,
        id: this.columnId
      });
      this.leftData = res.data.data.list;
      if (this.leftData[0] && this.leftData[0].children) {
        this.leftData[0].children = this.leftData[0].children.filter(item =>
            item.id !== 671 && item.id !== 653
        );
      }
      this.columnPid = res.data.data.pid.parentId
      console.log("栏目父id", this.columnPid);
      //通过栏目确定当前选中的栏目
      if (this.leftData[0]?.children.length > 0) {
        if (this.columnId == this.pid) {
          if (this.leftData[0].template == 'picture_column') {
            //如果是图片栏目
            this.currentItem = this.leftData[0];
          } else if (this.leftData[0]?.children[0]?.children.length > 0) {
            this.currentItem = this.leftData[0].children[0].children[0]
            console.log(0)
          } else {
            this.currentItem = this.leftData[0]?.children[0];
            console.log(1)
          }
        } else if (this.columnPid == this.pid) {
          let index = this.leftData[0]?.children.findIndex(item => item.id == this.columnId);
          this.currentItem = this.leftData[0]?.children[index]?.children[0]
          if (this.leftData[0]?.children[index]?.children.length > 0) {
            this.currentItem = this.leftData[0].children[index].children[0]
          } else {
            this.currentItem = this.leftData[0]?.children[index]
          }
        } else {
          console.log(3)
          this.currentItem = res.data.data.pid
        }
      } else {
        this.currentItem = this.leftData[0];
      }
      console.log(this.currentItem,this.leftData)
      console.log('当前选中的栏目为' + this.currentItem?.id)
      console.log('当前选中的栏目为' + this.currentItem?.name)

      if(this.currentItem.children && this.currentItem.children.length > 0){ // 判断有没有四级
        this.show = true
        this.showdata = this.currentItem.children
      }else{
        // 递归查找匹配的节点
        const findMatchingNode = (nodes, targetId) => {
          for (const node of nodes) {
            if (node.id == Number(targetId)) {
              return node;
            }
            if (node.children && node.children.length > 0) {
              const found = findMatchingNode(node.children, targetId);
              if (found) return found;
            }
          }
          return null;
        };

        const matchingNode = findMatchingNode(res.data.data.list,  this.currentItem?.id);
        console.log(matchingNode)
        this.show = true
        this.showdata = matchingNode.children
      }
      if (this.$store.state.stations.id == '1004' && this.currentItem?.name == '证书公告') {
        this.showAnnounce = true
      }
    },
    navTo(item) {
      this.$router.push(`/channels/${this.pid}/${item.id}.html`)
    },
    navTos(item){
      this.show = false
      this.$router.push(`/channels/${item.parentId}/${item.id}.html`)
    },
    queryClick(e) {
      this.showAnnounce = true;
      //查询通知公告内容
      this.queryParam = e
      this.$nextTick(function () {
        this.$refs.cert.getList()
      })
    },
  },
  computed: {
    ...mapState(['columnData']),
    bannerUrl() {
      if (this.leftData.length > 0 && this.leftData[0]?.imgUrl) {
        return this.$baseURL + this.leftData[0]?.imgUrl
      }
      return ''
    }
  }
}
</script>

<style scoped>
.mb {
  margin-bottom: 20px;
}

.mt {
  margin-top: 20px;
}
.bigWord {
  width: 835px;
  border-bottom: 2px solid #999;
  height: 44px;
  line-height: 44px;
  color: #2b9bdf;
  font-size: 16px;
  margin-top: 14px;
}
.lista {
  margin-bottom: 33px;
  width: 835px;
  margin-top: 10px;
  overflow: hidden;
}
.liDiv {
  float: left;
  width: 417px;
  box-sizing: border-box;
  font-size: 16px;
  color: #333;
  height: 20px;
  line-height: 16px;
  border-left: 6px solid #2b9bdf;
  padding-left: 10px;
  margin-top: 33px;
  cursor: pointer;
  display: flex
;
  align-items: center
}
.liDiv:hover {
  color: #09459b;
}
</style>
